import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class SocieteServiceService {

  host_Societe = `${environment.API_URI}/api/societe`;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getAllSocieteByCodeDo(code_do: number){
    const url = `${this.host_Societe}/select/all/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

 disableSociete(codeInternes: number[]) {
    const url = `${this.host_Societe}/disable`;
    const body = { code_interne: codeInternes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }

   enableSociete(codeInternes: number[]) {
    const url = `${this.host_Societe}/enable`;
    const body = { code_interne: codeInternes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }

  addSociete(Societe: any) {
    const url = `${this.host_Societe}/add`;
    return this.http.post(url, Societe, { headers: this.getAuthHeaders() });
  }

updateSociete(code_interne: number, Societe: any) {
    const url = `${this.host_Societe}/update/${code_interne}`;
    return this.http.put(url, Societe, { headers: this.getAuthHeaders() });
  }

  exportTemplatesociete() {
    const url = `${this.host_Societe}/export/template`;
    return this.http.get(url, {
      responseType: 'blob',
      headers: this.getAuthHeaders()
    });
  }

  importCsvSociete(code_do : number,add_on:string, file: File): Observable<HttpEvent<any>> {
    const url = `${this.host_Societe}/bulk-import/`;
    const formData = new FormData();
    formData.append('csvSocieteFile', file);

    const req = new HttpRequest('POST', url + code_do+'/' + add_on, formData, {
      reportProgress: true,
      headers: this.getAuthHeaders(),
      responseType: 'json'
    });

    return this.http.request(req);
  }
}
